export const setLocalStorageWithExpiry = (key, value, ttl) => {
  const data = {
    value,
    expiry: Date.now() + ttl,
  };
  localStorage.setItem(key, JSON.stringify(data));
}

export const getLocalStorageWithExpiry = key => {
  const itemStr = localStorage.getItem(key);
  if (!itemStr) return null;

  try {
    const data = JSON.parse(itemStr);
    if (Date.now() > data.expiry) {
      localStorage.removeItem(key);
      return null;
    }
    return data.value;
  } catch {
    localStorage.removeItem(key);
    return null;
  }
}